/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import * as Sentry from '@sentry/vue';
// Some users might want to block sentry which should be just fine.
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function withSentry(cb) {
    if (Sentry != null) {
        cb(Sentry);
    }
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function captureException(err) {
    withSentry(sentry => sentry.captureException(err));
    if (!IS_PRODUCTION) {
        // eslint-disable-next-line no-console
        console.error('Captured error', err);
    }
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function maybeCaptureException(probability, err) {
    if (Math.random() <= probability) {
        captureException(err);
    }
}
